import React from 'react';

const TastingNotes = (
  {
    StoryDescription,
    StoryHeadline,
    images
  }
) => {
  const img = 'https://via.placeholder.com/1600x900.png?text=FPO';

  const { storyImage1 } = images || {};

  return (
    <div>
      {StoryDescription &&
        StoryHeadline &&
        <section className="section-tasting-notes">
          <div className="row">
            <div className="col-md-6 offset-md-1">
              <h2 className="section">{StoryHeadline}</h2>
              <div dangerouslySetInnerHTML={{ __html: StoryDescription }} />
            </div>
          </div>
        </section>}
      {storyImage1 &&
        <section>
          <div className="row justify-content-center">
            <div className="col-md-10">
              <img src={storyImage1.href} alt="FPO" />
            </div>
          </div>
        </section>}
    </div>
  );
};

export default TastingNotes;
